var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStageStepBadgeNull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_1827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 108.9L122.5 75.4004C129.6 68.3004 129.6 56.7004 122.5 49.6004C115.4 42.5004 103.8 42.5004 96.7 49.6004L63.2 83.1004C56.1 90.2004 56.1 101.8 63.2 108.9C70.3 116 81.9 116 89 108.9Z",
    fill: "url(#paint0_linear_1414_1827)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M62.9002 108.9L29.4002 75.4004C22.3002 68.3004 22.3002 56.7004 29.4002 49.6004C36.5002 42.5004 48.1002 42.5004 55.2002 49.6004L88.7002 83.1004C95.8002 90.2004 95.8002 101.8 88.7002 108.9C81.6002 116 70.0002 116 62.9002 108.9Z",
    fill: "url(#paint1_linear_1414_1827)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1414_1827",
    x1: 57.8845,
    y1: 79.2546,
    x2: 127.837,
    y2: 79.2546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEAEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1414_1827",
    x1: 24.0624,
    y1: 79.2546,
    x2: 94.0145,
    y2: 79.2546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_1827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageStepBadgeNull);
export default __webpack_public_path__ + "static/media/stage-step_Badge_null.7d50ca747b769c76f4c92a54413fb82f.svg";
export { ForwardRef as ReactComponent };